import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3rr38dnsue: FaireBrandEntity = {
  token: "b_3rr38dnsue",
  type: "brand",
  name: "Les Belles Vagabondes",
  avatarUrl:
    "https://cdn.faire.com/fastly/8c9346828c951997641a92dd61d0db6e1d895ca93e88cda05ee5fe0c9b8374bd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c0ca0da596339612e2a2802d8c88e329b6d8d2c8732d7f4192b9497d0f2df2c8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8c9346828c951997641a92dd61d0db6e1d895ca93e88cda05ee5fe0c9b8374bd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c0ca0da596339612e2a2802d8c88e329b6d8d2c8732d7f4192b9497d0f2df2c8.jpeg",
  location: "FRA",
  minimumOrderDollars: 232,
  rating: 5,
  reviewCount: 234,
  isTopShop: true,
  isInsider: false,
  description:
    "Quality and originality are the key words for Les Belles Vagabondes\nThe fabrics have been chosen with great care, choosing only natural materials, 100% silk or 100% wool for the winter, 100% cotton for the summer. The thickness, the quality of the weaving... we took the time to find fabrics that fully satisfy us. Similarly, for printing, we have chosen traditional Indian techniques that have an excellent rendering.\nOur scarves are printed in a socially responsible workshop using ASO free inks.\nDesign is our asset, Les Belles Vagabondes are inspired by travel and all the discoveries that surround us and amaze us. Brazza is a scarf inspired by Bogolans brought back from Mali or Burkina Faso and also by three magnificent years spent in Congo Brazzaville. Another destination: the Urals with its wild herbs or cranes. The Octave or Symphony scarves were born from the discovery of Ernst Chladni's fascinating work on the figures of sound... Each scarf is born from a drawing...\nThe Belles Vagabondes are fashion accessories born with passion...\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:46.380Z",
    importedBy: "entity-db-cli",
  },
};
